import AmountDetailsBase from './base/AmountDetailsBase';

export const AMOUNT_DETAILS_MAP = {
	d1: {
		display: '$1',
		value: 1,
	},
	d5: {
		display: '$5',
		value: 5,
	},
	d10: {
		display: '$10',
		value: 10,
	},
	d20: {
		display: '$20',
		value: 20,
	},
	d50: {
		display: '$50',
		value: 50,
	},
	d100: {
		display: '$100',
		value: 100,
	},
	c1: {
		display: '1¢',
		value: 0.01,
	},
	c5: {
		display: '5¢',
		value: 0.05,
	},
	c10: {
		display: '10¢',
		value: 0.1,
	},
	c25: {
		display: '25¢',
		value: 0.25,
	},
	mixed: {
		display: 'Mixed',
		value: 1,
	},
}



const denominationArray = [
  { denomination: 'd1', value: 1 },
  { denomination: 'd5', value: 5 },
  { denomination: 'd10', value: 10 },
  { denomination: 'd20', value: 20 },
  { denomination: 'd50', value: 50 },
  { denomination: 'd100', value: 100 },
  { denomination: 'c1', value: 0.01 },
  { denomination: 'c5', value: 0.05 },
  { denomination: 'c10', value: 0.1 },
  { denomination: 'c25', value: 0.25 },
	{ denomination: 'mixed', value: 1 },
]

/**
 * @class AmountDetails
 * @extends AmountDetailsBase
 */
class AmountDetails extends AmountDetailsBase {

  /**
   * Convert count values to amount values
   * @returns {AmountDetails}
   */
  convertCountValuesToAmountValues () {

    const amountDetails = new AmountDetails()
    denominationArray.forEach(({ denomination, value }) => {
      const count = this[denomination]
      amountDetails[denomination] = count ? Number((count * value).toFixed(2)) : null
    })

    return amountDetails
  }

	convertAmountValuesToCountValues () {
		const amountDetails = new AmountDetails()
		denominationArray.forEach(({ denomination, value }) => {
			const amount = Number(this[denomination])
			if (denomination === 'mixed') {
				amountDetails[denomination] = amount
			} else {
				const remainder = amount ? (amount * 100) % (value * 100) : null
				// if remainder is not a integer, set to null
				amountDetails[denomination] = remainder === 0 ? +Number(amount / value).toFixed(2) : null
			}
		})

		return amountDetails
	}

  get total() {
    let result = Object.entries(this).filter(([key]) => key !== 'mixed').reduce((acc, [key, count = 0]) => {
      const { value = 0 } = AMOUNT_DETAILS_MAP[key] ?? {}
			const countValue = Number(count)
			if (Number.isInteger(countValue) && countValue >= 0) {
				const amount = Number((countValue * value).toFixed(2))
				return Number((acc + amount).toFixed(2))
			}
			return acc
    }, 0)
		const mixedAmount = this.mixed ? Number(this.mixed) : 0
		result += mixedAmount
		return result
  }

}

export default AmountDetails;
